module.exports = fox._r("images/messages.png", __webpack_public_path__ + "images/messages.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/messages.png
// module id = 1084
// module chunks = 4